import { Plan } from 'types'

export type Config = {
    locale: string
    isMigratedToMRML: boolean
    maxApp?: number
    features: Feature[]
    plan: Plan | null
    settings: {
        timezone: string
    }
}

export enum Feature {
	
	APPOINTMENT_MANAGEMENT = 'APPOINTMENT_MANAGEMENT',
	APPOINTMENT_REPORT = 'APPOINTMENT_REPORT',
	APPS = 'APPS',
	GROUP_APPOINTMENTS = 'GROUP_APPOINTMENTS',
    CALENDAR_SYNC = 'CALENDAR_SYNC',
    EXPERIENCE_SELECTOR = 'EXPERIENCE_SELECTOR',
    FLOWS = 'FLOWS',
    INSTANT_BOOKING = 'INSTANT_BOOKING',
    PERMISSIONS = 'PERMISSIONS',
    PERSONAL_ACCESS_TOKEN = 'PERSONAL_ACCESS_TOKEN',
    REMOVE_BRANDING = 'REMOVE_BRANDING',
    RESERVATION = 'RESERVATION',
    SERVICE_HOURS = 'SERVICE_HOURS',
    ADMIN_DRAFT_ORDER_WITHOUT_BOOKING = 'ADMIN_DRAFT_ORDER_WITHOUT_BOOKING',
    
    ADMIN_CHAT = 'ADMIN_CHAT',
    PORTAL_ONBOARDING = 'PORTAL_ONBOARDING',
    SENDER_EMAIL_DOMAIN_VERIFICATION = 'SENDER_EMAIL_DOMAIN_VERIFICATION',
    STOREFRONT_CALENDAR_V2 = 'STOREFRONT_CALENDAR_V2',
    STOREFRONT_SDK = 'STOREFRONT_SDK'

}
